module.exports = __webpack_public_path__ + "img/jyfc.490dd743.svg";